import { FC, useId } from 'react'

import { Checkbox, Cluster } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { useNotificationCenterSearch } from '../hooks/useNotificationCenterSearch'

const NOTIFICATION_QUICK_FILTERS = ['deviationRisk', 'deviation'] as const

export const NotificationsQuickFilters: FC = () => {
  const id = useId()
  const { translate } = useLocalisation()
  const { search, setSearch } = useNotificationCenterSearch()

  const selectedTypes = search.type || []

  return (
    <Cluster gap={8}>
      {NOTIFICATION_QUICK_FILTERS.map((filter) => (
        <Checkbox
          key={filter}
          id={`${id}-filter-${filter}`}
          label={translate(`notifications.filters.${filter}`)}
          checked={selectedTypes.includes(filter)}
          onCheckedChange={(checked) => {
            if (checked) {
              setSearch({ type: [...selectedTypes, filter] })
            } else {
              setSearch({
                type: selectedTypes.filter((f) => f !== filter),
              })
            }
          }}
        />
      ))}
    </Cluster>
  )
}
